module.exports = __webpack_public_path__ + "img/Progress-2.4815d546.svg";